import {logInfo} from '@/utilities/log';

function main(): void {
  if (!customElements.get('review-card-carousel')) {
    customElements.define('review-card-carousel', ReviewCardCarousel);
  }
}

class ReviewCardCarousel extends HTMLElement {
  intersectionObserver = new IntersectionObserver((entries) => {
    if (entries.some((e) => e.isIntersecting)) {
      logInfo('ReviewCardCarouselVisible');
      this.intersectionObserver.disconnect();
    }
  });

  connectedCallback() {
    this.intersectionObserver.observe(this);
    const prevButton = this.querySelector('[data-action="prev"]');
    const nextButton = this.querySelector('[data-action="next"]');
    const track = this.querySelector('[data-track]');

    if (!track) {
      return;
    }

    const maxScroll = track.scrollWidth - track.clientWidth;

    prevButton?.addEventListener('click', () => {
      logInfo('ReviewCardCarouselPreviousButtonClicked');
      // slight offset is expected due to scroll snap padding
      if (track.scrollLeft < 64) {
        track.scrollTo({
          left: maxScroll,
          behavior: 'smooth',
        });
      } else {
        track.scrollBy({left: -320, behavior: 'smooth'});
      }
    });

    nextButton?.addEventListener('click', () => {
      logInfo('ReviewCardCarouselNextButtonClicked');
      if (track.scrollLeft >= maxScroll) {
        track.scrollTo({left: 0, behavior: 'smooth'});
      } else {
        track.scrollBy({left: 320, behavior: 'smooth'});
      }
    });
  }

  disconnectedCallback() {
    this.intersectionObserver.disconnect();
  }
}

main();
